import { createRoute } from '@tanstack/react-router';
import { IconChecklist } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import { TasksRoute } from './TasksRoute';
import { TaskDetail } from './TaskDetail';

const admin: EzyModule = {
  nav: { key: 'admin', label: 'Việc & Duyệt', icon: IconChecklist, section: 'Nội bộ', items: [{ key: 'tasks', label: 'Việc & Duyệt', to: '/ezy/tasks' }] },
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/tasks', component: TasksRoute }),
    createRoute({ getParentRoute: () => parent, path: '/tasks/$kind/$id', component: TaskDetail }),
  ],
};
export default admin;
